import { Component, OnInit, inject } from '@angular/core';
import { LifeWizardService } from '../../../services/life-wizard.service';
import { Router, RouterLink } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PercentPipe } from '@angular/common';

@Component({
  selector: 'app-life-stats',
  templateUrl: './life-stats.component.html',
  styleUrls: ['./life-stats.component.scss'],
  imports: [
    NgxLoadingModule,
    MatCardModule,
    MatIconModule,
    RouterLink,
    PercentPipe,
  ],
})
export class LifeStatsComponent implements OnInit {
  private lws = inject(LifeWizardService);
  private router = inject(Router);

  state: string = 'loaded';
  data;

  ngOnInit() {
    this.lws.getLifeStats().subscribe(x => {
      this.data = x;
    });
  }

  goToProfile(ev, id) {
    this.router.navigate([`/li/questionnaire/${id}`]);
  }
}
